import { api } from '@/api';
import { useStore } from '@/engine/store';
import type { SetLocation } from '@shared/modelTypes/location-types';
import type { MemberId } from '@shared/modelTypes/session-types';
import { toast } from 'sonner';
import { setTag as sentrySetTag } from '@sentry/browser';

function ensureIsPlayer() {
	const currentState = useStore.getState();
	if (!currentState.location?.sessionId) return { success: false, message: 'Session not found' } as const;
	if (!currentState.playerState) return { success: false, message: 'Player not found' } as const;

	return {
		success: true,
		message: 'ok',
		sessionId: currentState.location.sessionId,
		memberId: currentState.playerState.id,
	} as const;
}

export const loadLocationState = async (data: SetLocation) => {
	const res = await api.getLocationByCode(data);

	toast(res.message);
	if (!res.success) {
		// TODO: consider some other way to handle this
		return;
	}

	sentrySetTag('location', res.data.id);
	useStore.getState().setLocation(res.data);

	// router.navigate({ to: '/set-player' });
};

export const startShift = async () => {
	const auth = ensureIsPlayer();
	if (!auth.success) return auth;

	return await api.startShift({ ...auth });
};

export const abortRepair = async () => {
	const auth = ensureIsPlayer();
	if (!auth.success) return auth;

	return await api.abortRepair({ ...auth });
};

export const extendRepairTime = async () => {
	const auth = ensureIsPlayer();
	if (!auth.success) return auth;

	return await api.extendRepairTime({ ...auth });
};

export const validateConnectionCode = async (code: string) => {
	const auth = ensureIsPlayer();
	if (!auth.success) return auth;

	return await api.validateConnectionCode({
		...auth,
		code,
	});
};

export const validateCode = async (code: string, memberId?: MemberId) => {
	const auth = ensureIsPlayer();
	if (!auth.success) return auth;

	return await api.validateCode({
		...auth,
		memberId: memberId ?? auth.memberId,
		code,
	});
};

export const assignTechToRoom = async (memberId: MemberId, roomId: string) => {
	const auth = ensureIsPlayer();
	if (!auth.success) return auth;

	return await api.assignTechToRoom({
		...auth,
		memberId,
		roomId,
	});
};

export const sendChatMessage = async (chatId: MemberId, message: string) => {
	const auth = ensureIsPlayer();
	if (!auth.success) return auth;

	return await api.sendChatMessage({
		...auth,
		chatId,
		message,
	});
};
